import {FC, ReactNode} from "react"
import decodeHtmlEntities from "../../../utilities/decoder"

type SEOProps = {
    title?: string | undefined | null
    description?: string | undefined | null
    image?: string | undefined | null
    imageAlt?: string | undefined | null
    siteUrl?: string | undefined | null
    twitterCard?: "summary" | "summary_large_image" | "player" | "app" | undefined | null
    twitterUsername?: string | undefined | null
    children?: ReactNode
    language?: string | undefined | null
}

export const SEO: FC<SEOProps> = seo => {
    const language = seo.language ?? process.env.DEFAULT_LANGUAGE
    const title = seo.title ? `AdKaora | ${seo.title}` : process.env.SITE_TITLE
    const description = seo.description
        ? decodeHtmlEntities(seo.description)
        : seo.language === "it"
        ? "AdKaora è il tuo MOBILE LIFE EXPERT"
        : "AdKaora is your MOBILE LIFE EXPERT"
    const image = seo.image ?? `${process.env.SITE_URL}/icons/icon-512x512.png`
    const imageAlt = seo.imageAlt ?? ""
    const url = seo.siteUrl ?? process.env.SITE_URL
    const twitterCard = seo.twitterCard ?? "summary_large_image"

    return (
        <>
            <html lang={language} />

            <title>{title}</title>

            <meta name="description" content={description} />
            <meta name="image" content={image} />

            <meta property="og:title" content={title} />
            <meta property="og:url" content={url} />
            <meta property="og:description" content={description} />
            <meta property="og:locale " content={language} />
            <meta property="og:image" content={image} />
            <meta property="og:image:alt" content={imageAlt} />

            <meta name="twitter:card" content={twitterCard} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:creator" content={imageAlt} />
            {seo.children}
        </>
    )
}
